import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import type { NewPayment } from '@/models/payments';
import type { ColumnDef } from '@tanstack/vue-table';
import { ArrowUpDown } from 'lucide-vue-next';
import { h } from 'vue';
import { displayCurrency, displayDate } from '../../../../utils/format.utils';

export const paymentsRegisterColumns: ColumnDef<NewPayment>[] = [
  {
    accessorKey: 'client',
    header: 'Customer Name',
    enableSorting: false,
    cell: ({ getValue }) => {
      const name = getValue() as string;
      return h('div', name);
    },
  },
  {
    accessorKey: 'orderReference',
    header: 'Order Reference',
    enableSorting: false,
    cell: ({ getValue }) => {
      const name = getValue() as string;
      return h('div', name);
    },
  },
  {
    accessorKey: 'orderName',
    header: 'Order Name',
    enableSorting: false,
    cell: ({ getValue }) => getValue(),
  },
  {
    accessorKey: 'paymentType',
    header: 'Payment Type',
    enableSorting: false,
    cell: ({ getValue }) => getValue(),
  },
  {
    accessorKey: 'paymentMethod',
    header: 'Method',
    enableSorting: false,
    cell: ({ getValue }) => getValue(),
  },
  {
    accessorKey: 'settlementBatch',
    header: 'Settlement Batch',
    enableSorting: false,
    cell: ({ getValue }) => getValue(),
  },
  {
    accessorKey: 'due',
    header: ({ column }) => {
      return h(
        Button,
        {
          class: '!p-0',
          variant: 'ghost',
          onClick: () => column.toggleSorting(column.getIsSorted() === 'asc'),
        },
        () => ['Due Date', h(ArrowUpDown, { class: 'ml-2 h-4 w-4' })],
      );
    },
    enableSorting: true,
    cell: ({ getValue }) => {
      const dueDate = getValue() as string;
      return h('div', displayDate(dueDate));
    },
  },
  {
    accessorKey: 'amount',
    header: ({ column }) => {
      return h(
        Button,
        {
          class: '!p-0',
          variant: 'ghost',
          onClick: () => column.toggleSorting(column.getIsSorted() === 'asc'),
        },
        () => ['Amount', h(ArrowUpDown, { class: 'ml-2 h-4 w-4' })],
      );
    },
    enableSorting: true,
    cell: ({ getValue }) => {
      const amount = getValue() as number;
      return h('div', { class: 'text-right' }, displayCurrency(amount));
    },
  },
  {
    accessorKey: 'fee',
    header: () => {
      return h('div', { class: 'text-right' }, 'Fee');
    },
    enableSorting: false,
    cell: ({ getValue }) => {
      const amount = getValue() as number;
      return h('div', { class: 'text-right' }, displayCurrency(amount));
    },
  },
  {
    accessorKey: 'paymentStatus',
    header: 'Status',
    enableSorting: false,
    cell: ({ getValue }) => {
      const state = getValue() as string;
      let variant: 'error' | 'success' | 'warning' | 'info' = 'success';

      if (state === 'FAILED') variant = 'error';
      if (state === 'DUE' || state === 'MISSED') variant = 'warning';
      if (state === 'SETTLED' || state === 'PENDING') variant = 'info';

      return h(Badge, { class: 'text-xs', variant }, () => state);
    },
  },
  {
    accessorKey: 'verifiedAt',
    header: ({ column }) => {
      return h(
        Button,
        {
          class: '!p-0',
          variant: 'ghost',
          onClick: () => column.toggleSorting(column.getIsSorted() === 'asc'),
        },
        () => ['Paid Date', h(ArrowUpDown, { class: 'ml-2 h-4 w-4' })],
      );
    },
    enableSorting: true,
    cell: ({ getValue }) => {
      const paidDate = getValue() as string;
      return h('div', displayDate(paidDate));
    },
  },
];
